import { Component, OnInit } from '@angular/core';
import { UserService } from '../../../shared/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorHandler } from '../../../shared/ErrorHandler';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';

@Component({
  selector: 'app-project-form',
  templateUrl: './project-form.component.html',
  styleUrls: ['./project-form.component.css']
})
export class ProjectFormComponent implements OnInit {

  project:any={};
  data:any;
  c:any={};
  roles;
  projectslist;
  Namelist;
  coordinators: any;
  mode: any;
  Tr_Pro_Id: any;
  formSubmitted: boolean;
  constructor(private userService: UserService, private router: Router,private route: ActivatedRoute,private errorHandler:ErrorHandler) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.mode = params['mode'];
      this.Tr_Pro_Id = params['Tr_Pro_Id'];
    });
    
    if (this.Tr_Pro_Id != null && this.mode!=null) 
      this.GetProject(this.Tr_Pro_Id);

      if(this.mode!='view'|| this.mode!='edit')
      {       
        this.GetAllRoles();
        this.GetProjectsforRoles();
        this.GetAllCoordinators();
      }  
  }
  GetAllRoles() {
    // if (this.user != null) {
    //   this.user.RoleId=undefined;
    debugger;
      document.getElementById('loader-spinner').style.display = "block";
      this.data = this.userService.getRolesforSelectedOffice();
      this.data.subscribe(
        (response:any) => {
          this.roles = response;
          // if(this.mode!=null)
          //   this.user.RoleId=this.roleId;
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
    // }
  }

  GetNamesbyrole(roleId:any) {
    debugger;
    // if (this.user != null) {
    //   this.user.RoleId=undefined;
      document.getElementById('loader-spinner').style.display = "block";
      this.data = this.userService.GetNamesbyrole(roleId);
      this.data.subscribe(
        (response:any) => {
          this.Namelist = response;
          // if(this.mode!=null)
          //   this.user.RoleId=this.roleId;
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
    // }
  }
  GetProjectsforRoles() {
    debugger;
    // if (this.user != null) {
    //   this.user.RoleId=undefined;
      document.getElementById('loader-spinner').style.display = "block";
      this.data = this.userService.GetProjectsforRoles();
      this.data.subscribe(
        (response:any) => {
          this.projectslist = response;
          // if(this.mode!=null)
          //   this.user.RoleId=this.roleId;
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
    }

    GetAllCoordinators() {
      debugger;
        document.getElementById('loader-spinner').style.display = "block";
        this.data = this.userService.GetAllCoordinators();
        this.data.subscribe(
          (response:any) => {
            this.coordinators = response;
            // if(this.mode!=null)
            //   this.user.RoleId=this.roleId;
            document.getElementById('loader-spinner').style.display = "none";
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
            this.errorHandler.HandlerError(error);
          });
    }

    onSubmit(projectform: NgForm) {
      debugger;
      if (!projectform.invalid) {
        document.getElementById('loader-spinner').style.display = "block";
        this.data = this.userService.SaveProjectDetails(projectform.value);
        this.data.subscribe(
          (response) => {
            document.getElementById('loader-spinner').style.display = "none";
            swal('Success!', 'Saved Successfully.', 'success');
            this.router.navigate(['/home/projects']);
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
             //this.errorHandler.HandlerError(error);
          });
      }
      else {
        document.getElementById('loader-spinner').style.display = "none";
        swal('Warning!', 'Please Enter all the mandatory fields.', 'warning');
      }
    }

    GetProject(Tr_Pro_Id) {
      debugger;
      if (Tr_Pro_Id != undefined) {
        document.getElementById('loader-spinner').style.display = "block";
        this.data = this.userService.getProject(Tr_Pro_Id);
        this.data.subscribe(
          (response) => {
            this.project = response;
            document.getElementById('loader-spinner').style.display = "none";
          }, (error) => {
            console.log(error);
            document.getElementById('loader-spinner').style.display = "none";
          });
      }
    }


    Update(projectform: NgForm) {
      debugger;
      if (!projectform.invalid) {
      document.getElementById('loader-spinner').style.display = "block";
      this.data = this.userService.updateprojectdetails(projectform.value,this.Tr_Pro_Id);
      this.data.subscribe(
          (response) => {
            document.getElementById('loader-spinner').style.display = "none";
            swal('','Updated Successfully!','success');
            this.router.navigate(['/home/projects']);
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
            alert(error.error.Message);
          });
        }else{
          document.getElementById('loader-spinner').style.display = "none";
          swal('warning','Please fill all the mandatory fields!','warning');
          this.formSubmitted = true;
          }
    }

    Cancel(){
      this.project={};
    }
  
    

}



// WEBPACK FOOTER //
// ./src/app/masters/project/project-form/project-form.component.ts